/**
 * 海螺01（image-01）manifest
 * 数据来源：image.json field_map
 * 特点：支持参考图-人物长相（ref_type 仅 value=2，无角色特征）；参考图上限 1；比例带真实像素
 */
import type { ImageModelConfig } from '../../types';

export const hailuo01: ImageModelConfig = {
  id: '01K5THSZ1EPZYJAH20CP0MKQCT',
  displayName: '海螺01',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
    refType: 2, // 接口 ref_type.default
  },

  ratioOptions: {
    '*': [
      { label: '1:1', value: '1:1', width: 1024, height: 1024 },
      { label: '2:3', value: '2:3', width: 832, height: 1248 },
      { label: '3:2', value: '3:2', width: 1248, height: 832 },
      { label: '3:4', value: '3:4', width: 864, height: 1152 },
      { label: '4:3', value: '4:3', width: 1152, height: 864 },
      { label: '9:16', value: '9:16', width: 720, height: 1280 },
      { label: '16:9', value: '16:9', width: 1280, height: 720 },
      { label: '21:9', value: '21:9', width: 1344, height: 576 },
    ],
  },

  resolutionOptions: [],
  qualityOptions: [],

  refTypeOptions: [
    { label: '人物长相', value: 2, min: 0, max: 1, select: true },
  ],

  // 海螺01 不支持参考图-角色特征（field_map.ref_type 仅人物长相，无角色特征）
  supportsReferenceRoleImage: false,

  toggles: {},

  limits: {
    maxRefImages: 1, // 接口 field_map.ref_images.max
    // 生成图尺寸校验（转写自 verification.ts 原海螺01 硬编码：宽/高 ∈ [512, 2048]）
    generationConstraints: {
      dimension: { min: 512, max: 2048 },
    },
  },
};
